import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllAsync as fetchAllClientesAsync, selectClientes } from '../../features/cliente/clienteSlice';
import { fetchAllAsync as fetchAllFornecedoresAsync, selectFornecedoresFavorecidos } from '../../features/fornecedor-favorecido/FornecedorSlice';
import {
  fetchFilteredAsync,
  selectEmpresasEstrangeiras,
} from '../../features/empresa-estrangeira/empresaEstrangeiraSlice';
import QCXAutocompleteSelectWithSearch from '../autocomplete-select/QCXAutocompleteSelectWithSearch';

const PAGADOR_TIPO = {
  CLIENTE: 'CLIENTE',
  FORNECEDOR: 'FORNECEDOR',
  EMPRESA_ESTRANGEIRA: 'EMPRESA_ESTRANGEIRA',
};

export { PAGADOR_TIPO };

const getNome = (item) => {
  if (item._pagadorTipo === PAGADOR_TIPO.EMPRESA_ESTRANGEIRA) {
    return item?.pessoaJuridica?.nomeResumido || item?.pessoaJuridica?.nome || item?.description || '';
  }
  return item?.pessoa?.nomeResumido || item?.pessoa?.nome || '';
};

const getTipoLabel = (tipo) => {
  if (tipo === PAGADOR_TIPO.CLIENTE) return 'Cliente';
  if (tipo === PAGADOR_TIPO.FORNECEDOR) return 'Favorecido';
  return 'Emp. Estrangeira';
};

const filterOptions = createFilterOptions({
  stringify: (item) => `${item.id} - ${getNome(item)}`,
});

const getOptionLabel = (item) => {
  if (!item?.id) return '';
  return `${item.id} - ${getNome(item)} [${getTipoLabel(item._pagadorTipo)}]`;
};

export default function QCXSelectPagadorAutocomplete({ label, name, initialValues, ...restProps }) {
  const dispatch = useDispatch();

  const clientes = useSelector(selectClientes);
  const fornecedores = useSelector(selectFornecedoresFavorecidos);
  const empresasEstrangeiras = useSelector(selectEmpresasEstrangeiras);

  const [combinedList, setCombinedList] = useState([]);
  const [defaultValue, setDefaultValue] = useState(null);

  useEffect(() => {
    dispatch(fetchAllClientesAsync());
    dispatch(fetchAllFornecedoresAsync());
    dispatch(fetchFilteredAsync());
  }, []);

  useEffect(() => {
    const pagadorFromInitial = _.get(initialValues, name);
    if (!pagadorFromInitial?.id || !pagadorFromInitial?._pagadorTipo || combinedList.length === 0) return;
    const found = combinedList.find(
      (item) => item.id === pagadorFromInitial.id && item._pagadorTipo === pagadorFromInitial._pagadorTipo
    );
    setDefaultValue(found || null);
  }, [combinedList, initialValues, name]);

  useEffect(() => {
    const taggedClientes = clientes
      .filter((c) => c?.active)
      .map((c) => ({ ...c, _pagadorTipo: PAGADOR_TIPO.CLIENTE }));

    const taggedFavorecidos = fornecedores
      .filter((f) => f?.active && f?.favorecido)
      .map((f) => ({ ...f, _pagadorTipo: PAGADOR_TIPO.FORNECEDOR }));

    const taggedEmpresas = empresasEstrangeiras
      .map((e) => ({ ...e, _pagadorTipo: PAGADOR_TIPO.EMPRESA_ESTRANGEIRA }));

    setCombinedList([...taggedClientes, ...taggedFavorecidos, ...taggedEmpresas]);
  }, [clientes, fornecedores, empresasEstrangeiras]);

  const searchEmpresasEstrangeiras = (value) => {
    dispatch(fetchFilteredAsync(value));
  };

  return (
    <QCXAutocompleteSelectWithSearch
      label={label}
      id={name}
      name={name}
      options={combinedList}
      filterOptions={filterOptions}
      defaultValue={null}
      getOptionLabel={getOptionLabel}
      getOptionValue={(item) => item}
      onEventActionPaiFunction={searchEmpresasEstrangeiras}
      placeholder="Selecione um Cliente, Favorecido ou Empresa Estrangeira"
      {...restProps}
    />
  );
}
